import React, { CSSProperties, FC } from 'react'
import { format } from 'date-fns'
import { PricingTimeslot } from './types'
import { Card } from '@mui/material'
import './timeslots.scss'
import { convertTimeFormat, DateFormats } from 'utils'
import { useTranslation } from 'translations'

interface Props {
    timeslots: PricingTimeslot[]
    selectedDate: Date
    style?: CSSProperties
}

const Timeslots: FC<Props> = ({ timeslots, selectedDate, style }) => {
    const { t } = useTranslation()
    const formatTimes = (timeSlot: PricingTimeslot) =>
        `${convertTimeFormat(timeSlot.startTime!)} - ${timeSlot.endTime ? convertTimeFormat(timeSlot.endTime) : ''}`

    return (
        <Card variant="outlined" style={style} className="gps-timeslots-card">
            <h6>{t('globalPricingSettings.studio.timeslots.title', { date: format(selectedDate, DateFormats.LONG_DATE) })}</h6>
            <div className="timeslots">
                {timeslots.map((timeslot, index) => (
                    <div className="timeslot" key={index}>
                        <span className="label">{formatTimes(timeslot)}</span>
                        <span style={{ color: timeslot.color }}>{timeslot.price ?? t('globalPricingSettings.studio.timeslots.notAvailable')}</span>
                    </div>
                ))}
            </div>
        </Card>
    )
}

export default Timeslots
